/**
 * Flux singleton
 * @module
 */

var FluxFactory = require('./lib/flux_factory');

/**
 * @type {Flux}
 */
module.exports = FluxFactory.create();
